import { lazy } from 'react';
import { Route, Routes } from 'react-router';
import { NotFound } from '../../app/routing/NotFound';
import { usersFullPath } from '../../pathDefinitions';
import UserCompanyDetails from './details/UserCompanyDetails';

const ListUsersRoute = lazy(() => import('./list/ListUsersRoute'));
const UserDetailsRoute = lazy(() => import('./details/UserDetailsRoute'));

export const userIdParam = 'userId';
export const companyIdParam = 'companyId';

export const userCompanyRoute = (userId: string, companyId: string) =>
  `${usersFullPath}/${userId}/company/${companyId}`;

export default function AdminUserRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ListUsersRoute />} />
      <Route path={`:${userIdParam}`} element={<UserDetailsRoute />} />
      <Route
        path={`:${userIdParam}/company/:${companyIdParam}`}
        element={<UserCompanyDetails />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
